import DocumentTitle from "react-document-title";
import UnderConstruction from "../Components/UnderConstruction";

export default function ContactUs() {
  return (
    <DocumentTitle title="Contact us">
      <UnderConstruction />
    </DocumentTitle>
  );
}
